import { useState } from "react";

import { IInstantNotifier } from "../Lib/Notifier/types";
import { ILog } from "../Lib/Log/types";
import { SERVICE_WORKER_REGISTRATION_LOG_EVENT_CHANNEL_NAME, SERVICE_WORKER_REGISTRATION_NEWVERSION_EVENT_CHANNEL_NAME } from "../ServiceWorker/constants";
import { IServiceWorkerStatus } from "../Features/ServiceWorker/types";
import { IServiceWorkerRegistrationLogEvent, IServiceWorkerRegistrationNewAppVersionAvailableEvent } from "../ServiceWorker/types";


const useServiceWorkerStatus = (notifier: IInstantNotifier, log: ILog): IServiceWorkerStatus => {

    const [hasNewAppVersion, setHasNewAppVersion] = useState(false);

    const logBroadcastChannel = new BroadcastChannel(SERVICE_WORKER_REGISTRATION_LOG_EVENT_CHANNEL_NAME);
    const newVersionBroadcastChannel = new BroadcastChannel(SERVICE_WORKER_REGISTRATION_NEWVERSION_EVENT_CHANNEL_NAME);  

    logBroadcastChannel.onmessage = (event) => {
        const data = event.data as IServiceWorkerRegistrationLogEvent;

        if (data.type === "error")
            log.error(data.message, data.data);
        else if (data.type === "warning")
            log.warning(data.message, data.data);
        else
            log.info(data.message, data.data);
    };

    newVersionBroadcastChannel.onmessage = (event) => {
        const data = event.data as IServiceWorkerRegistrationNewAppVersionAvailableEvent;

        setHasNewAppVersion(true);

        log.info("New app version available", data);
        notifier.info("New app version available. Please close and re-open to update.");
    };

    return {
        hasNewAppVersion
    };

};

export default useServiceWorkerStatus;